import ky from 'ky'
import cookie from 'js-cookie'
import { useEventBus, useThrottleFn } from '@vueuse/core'
import { defaultLang, getHeaderLang, getRestLocale } from '@/utils/locale'
import { getDeviceId, getTokenByUrl, getTopDomainByUrl } from '~/utils/tools'

const { emit } = useEventBus('message')
const throttle = useThrottleFn(({ code, message, msg }) => {
  emit(code, message || msg)
}, 0)
const beforeRequest = [
  async (request, options) => {
    const {
      tokenName,
      cookieName,
      requestTrasform,
      modified,
      data,
      ignoreGranting,
    } = options
    request.headers.set('exch-language', import.meta.client ? getRestLocale(getHeaderLang()) : defaultLang)

    if (tokenName && !ignoreGranting && import.meta.client) {
      const value = getTokenByUrl() || localStorage.token || cookie.get(cookieName || tokenName)
      if (value) {
        request.headers.set(tokenName, value)
        request.headers.set('authorization', `Bearer ${value}`)
      }
    }
    if (options.timeout && request.method === 'POST') {
      options.timeoutId = setTimeout(() => {
        throttle({ code: -1 })
      }, options.timeout)
    }
    if (!modified) {
      if (data) {
        request.headers.set('content-type', 'application/json') // NOTE: fix content type when use "data" as parameter
        if (requestTrasform) {
          const o = {}
          for (const k in data)
            o[requestTrasform(k)] = data[k]

          options.body = JSON.stringify(o)
        }
        if (!options.body)
          options.body = JSON.stringify(data)

        options.modified = true
        return ky(request, options)
      }
    }
  },
]

const needAuthCodes = [
  512,
  401,
  403,
  10000,
]
function makeErrorResponse(message = 'Network Error', code = 503) {
  return new Response(JSON.stringify({
    message,
    code,
    success: false,
  }), {
    status: code,
  })
}
const afterResponse = [
  async (request, options, response) => {
    clearTimeout(options.timeoutId)
    if (response.status > 200 && response.status !== 401) {
      const message = 'Network Error'
      return makeErrorResponse(message, response.status)
    }
    /** @type {Response} */
    const clone = response.clone()
    const json = await clone.json().catch(_ => ({ code: 500 }))
    Object.assign(json, {
      code: json.code,
      message: json.message || json.msg,
      success: json.success || +json.code === 0 || +json.code === 200,
    })
    if (needAuthCodes.includes(+json.code) && import.meta.client) {
      if (localStorage.token || cookie.get('exch-token')) {
        cookie.remove('exch-token', {
          domain: `.${getDomain()}`,
        })
         cookie.remove('partner-token', {
          domain: getTopDomainByUrl(),
        })
        localStorage.token = ''
        return location.reload()
      }
    }
    else if (request.method === 'POST') {
      if (options.ignoreSuccessMessage) {
        !json.success && throttle(json)
      }
      else if (!options.ignoreMessage) {
        throttle(json)
      }
    }

    return new Response(JSON.stringify(json), {
      status: 200,
    })
  },
]
const beforeRetry = [
  ({ error }) => {
    if (error) {
      // throttle();
    }
  },
]

/** @type RequestInfo */
const commonOptions = {
  timeout: 30000,
  hooks: {
    beforeRequest,
    afterResponse,
    beforeRetry,
  },
  headers: {
    'exch-Device-ID': import.meta.client ? getDeviceId() : '',
    'exch-language': import.meta.client ? getRestLocale(getHeaderLang()) : defaultLang,
    'exch-Client-Type': 'PC',
    'exch-id': 1,
  },
  credentials: 'omit',
}
const futureApiOrigin = import.meta.client ? `https://api-swap.${getDomain()}` : import.meta.env.VITE_FUTUER_API_ORIGIN
const apiOrigin = import.meta.client ? `https://api-spot.${getDomain()}` : import.meta.env.VITE_DEFAULT_API_ORIGIN

export const apiFuture = ky.extend({
  ...commonOptions,
  prefixUrl: `${futureApiOrigin}/api`,
  tokenName: 'exch-token',
  granting: null,
})

export const api = ky.extend({
  ...commonOptions,
  prefixUrl: `${apiOrigin}/api`,
  tokenName: 'exch-token',
  granting: null,
})

export const apiX = ky.extend({
  ...commonOptions,
  prefixUrl: `${apiOrigin}/api-x`,
  tokenName: 'exch-token',
  granting: null,
})

export const v1 = ky.extend({
  ...commonOptions,
  prefixUrl: `${apiOrigin}/v1`,
  tokenName: 'exch-token',
  granting: null,
  // requestTrasform: snakeCase,
})

export const v2 = ky.extend({
  ...commonOptions,
  prefixUrl: `${apiOrigin}/v2`,
  tokenName: 'exch-token',
  granting: null,
  // requestTrasform: snakeCase,
})
